import { Component, OnInit, Input, ViewChild, OnDestroy, Signal, SimpleChanges, OnChanges } from "@angular/core";
import { IonSearchbar, PopoverController } from "@ionic/angular";
import { Subject, Subscription } from "rxjs";
import { debounceTime, distinctUntilChanged } from "rxjs/operators";
import { EventsService } from "src/app/services/event/event.service";
import { GameHubControllerService } from "src/app/services/gameHub/game-hub-controller";
import { LobbyNavigator } from "src/app/services/lobby/lobby-navigator.service";
import { LobbyService } from "src/app/services/lobby/lobby.service";
import { MobileDataService } from "src/app/services/mobile-data/mobile-data.service";
import { UserSessionService } from "src/app/services/user-session/user-session.service";
import { Navigator } from "../../menu/navigator";
import { LobbyInitService } from "src/app/services/lobby/lobby-init.service";
import { HighlightSearchPipe } from "src/app/pipes/highlight-search.pipe";
import { FilterDataPipe } from "src/app/pipes/filter-data.pipe";

@Component({
  selector: "app-mobile-searchbar",
  templateUrl: "./searchbar.component.html",
  styleUrls: ["./searchbar.component.scss"],
  imports: [
    HighlightSearchPipe,
    FilterDataPipe
  ],
})

export class SearchbarComponent implements OnInit, OnDestroy {
  @ViewChild(IonSearchbar) myInput: IonSearchbar;
  public showKeyWords: boolean = false;
  public hideGames: boolean = false;
  public showCloseButton: boolean = false;
  public subscriptionFocus: Subscription;
  public keyWordsArray: any = "";
  public keyWordQueryChanged: Subject<any> = new Subject<any>();
  public focus$: Subject<string> = new Subject<string>();
  public isAuthenticated: boolean = false;
  public imagesPath: string;
  public keywordsSignal: Signal<any[]>;
  public keyWordsListData: any[] = [];
  public allGamesDataArray: any[] = [];
  private gamesSubscription: Subscription;
  // "https://sdtest-cdn.palainteractive.com/assets/social/games/"; // this.LobbyService.galleryImagePath;

  constructor(
    public events: EventsService,
    public gameHubController: GameHubControllerService,
    public lobbyService: LobbyService,
    public popoverController: PopoverController,
    public userSession: UserSessionService,
    public mobileData: MobileDataService,
    public navigator: Navigator,
    private lobbyNavigator: LobbyNavigator,
    private lobbyInit: LobbyInitService
  ) {
    this.keyWordQueryChanged
      .pipe(debounceTime(100), distinctUntilChanged())
      .subscribe((model) => {
        this.keyWordsArray = model;
      });

    this.subscriptionFocus = this.focus$
      .pipe(debounceTime(25))
      .subscribe((ev) => {
        this.onFocus(ev);
      });
  }

  ngOnInit() {
    this.initKeyWords();
    this.events.destroy('event:mobile-search-keyword-updated');
    this.events.subscribe('event:mobile-search-keyword-updated', () => {
      this.initKeyWords();
    });
    this.userSession.isAuthenticated().then(isAuthenticated => {
      if (isAuthenticated) {
        this.isAuthenticated = true;
      }
    });
    this.imagesPath = this.lobbyService.galleryImagePath;
    this.userSession.getUserStatus().subscribe((userStatus) => {
      if (userStatus == null) this.isAuthenticated = false;
      else this.isAuthenticated = true;
    });

    // Subscribe to games$ from LobbyInitService
    this.gamesSubscription = this.lobbyInit.games$.subscribe((games: any) => {
      this.allGamesDataArray = this.flattenAllGames(games);
    });
  }

  private initKeyWords() {
    this.lobbyInit.keywords$.subscribe(keywords => {
      this.keyWordsListData = keywords;
    });
  }
  
  flattenAllGames(allGames: { [key: string]: any[] }): any[] {
    if (!allGames) {
      return [];
    }
  
    // Convert allGames object to an array of arrays
    const allCasinoGames: any[] = Object.keys(allGames).map(key => allGames[key]);
  
    // Flatten the array of arrays into a single array
    return allCasinoGames.reduce((a, b) => a.concat(b), []);
  }

  onDataSelected(data) {
    this.showKeyWords = false;
    this.events.publish("keyword:click", data);
    this.hideGamesList();
  }

  onFieldChange(keywordQuery) {
    this.showKeyWords = keywordQuery === "";
    this.keyWordQueryChanged.next(keywordQuery);
  }

  onFocus(ev: any) {
    this.showKeyWords = this.keyWordsArray === "";
    this.showCloseButton = true;
    this.hideGames = false;
  }

  onBlur(): void {
    setTimeout(() => {
      this.showKeyWords = false;
      if (this.keyWordsArray === "") {
        this.showCloseButton = false;
      }
      this.onCloseClick();
    }, 100);
  }

  launchCasinoGame(gameData) {
    if (!this.isAuthenticated) {
      this.lobbyService.setWaitingGameData(gameData);
      this.onLogin();

    } else {
      this.hideGamesList();
      this.closeGame();
      setTimeout(() => {
        this.gameHubController.launchCasinoGame(gameData);
      }, 300);
    }
  }

  onLogin() {
    this.navigator.navigateTo("LoginComponent");
  }

  onCloseClick() {
    this.keyWordsArray = "";
    this.showCloseButton = false;
  }

  closeGame() {
    this.events.publish("event:game:close");
    this.gameHubController.killAllInstances();
  }

  ngOnDestroy() {
    this.subscriptionFocus.unsubscribe();
    if (this.gamesSubscription) {
      this.gamesSubscription.unsubscribe();
    }
  }

  hideGamesList() {
    this.hideGames = true;
  }

  singleMultipleLiveDealerFlow(gameData) {
  }
}
